import { Helmet } from "react-helmet";

const DEFAULT_IMAGE = "https://bitbytefoods.com/images/bbf2-min.png";

const Seo = (props) => {
  const { baseUrl, pathSlug, title, description, keywords, type, image } =
    props.data;
  const root = baseUrl.replace(/\/$/, "");
  const canonical = pathSlug === "/" ? `${root}/` : `${root}/${pathSlug.replace(/^\/+/, "")}`;
  const ogImage = image || DEFAULT_IMAGE;

  return (
    <Helmet
      htmlAttributes={{ lang: "en" }}
      title={title}
      meta={[
        {
          name: "description",
          content: description,
        },
        {
          name: "keywords",
          content: keywords,
        },
        {
          property: "og:title",
          content: title,
        },
        {
          property: "og:description",
          content: description,
        },
        {
          property: "og:type",
          content: type || "website",
        },
        {
          property: "og:url",
          content: canonical,
        },
        {
          property: "og:image",
          content: ogImage,
        },
        {
          property: "og:site_name",
          content: "Bit Byte Foods",
        },
        {
          property: "og:locale",
          content: "en_IN",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
        {
          name: "twitter:title",
          content: title,
        },
        {
          name: "twitter:description",
          content: description,
        },
        {
          name: "twitter:image",
          content: ogImage,
        },
      ]}
      link={[
        {
          rel: "canonical",
          key: canonical,
          href: canonical,
        },
      ]}
    />
  );
};
export default Seo;
